import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'gnx-avatar',
  template: `
    <div
      [style.width.px]="size()"
      [style.height.px]="size()"
      [style.background-color]="bgColor()"
      [style.font-size.px]="size() / textSizeRatio()"
      [style.font-family]="'Helvetica, Arial, sans-serif'"
      class="flex items-center justify-center rounded-full text-white font-normal uppercase select-none"
    >
      {{ initials }}
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarComponent {
  readonly name = input('');
  readonly bgColor = input('#007da8');
  readonly size = input(50);
  readonly textSizeRatio = input(3);

  get initials(): string {
    const name = this.name();
    if (!name) {
      return '';
    }
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) {
      return parts[0][0];
    }
    return parts[0][0] + parts[parts.length - 1][0];
  }
}
